import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query RequestTypesByTeam($teamId: ID!) {
  requestTypes(teamId: $teamId) {
    id
    name
    description
    defaultType
    active
    system
    keywords {
      token
    }
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

function fetchRequestTypesByTeam(teamId) {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
    variables: { teamId },
  }).then((res) => res.data.requestTypes);
}

export default fetchRequestTypesByTeam;
